import {
    NinchatState,
    NinchatStore,
} from 'api/types'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatChannelMemberJoinedEvent} from '../types/events'
import {extractProperties} from './'

export const channelMemberJoined: CaseReducer<NinchatState> = (state, action) => {
    const {
        channel_id,
        user_attrs,
        user_id,
        ...properties
    } = extractProperties<NinchatChannelMemberJoinedEvent>(action.payload)

    if (user_id === state.user_id) {
        state.user_attrs = {
            ...state.user_attrs,
            ...user_attrs,
        }
    } else {
        state._users[user_id] ??= {} as NinchatStore.NinchatStoreUser

        state._users[user_id].user_attrs = {
            ...state._users[user_id].user_attrs,
            ...user_attrs,
        }
    }

    state.user_channels[channel_id] ??= {channel_attrs: {}}
    const {
        channel_members = {},
        channel_members_metadata = {},
    } = state.user_channels[channel_id]

    channel_members[user_id] ??= {}
    channel_members[user_id] = properties

    const {member_metadata = {}} = properties

    if (Object.keys(member_metadata).length) {
        channel_members_metadata[user_id] ??= {}
        channel_members_metadata[user_id] = member_metadata
    }

    state.user_channels[channel_id].channel_member_count = Object.keys(channel_members).length
}
